import { Engine, Actor, Color, Vector, CollisionType, Animation, SpriteSheet, vec } from 'excalibur';
import { Resources } from '../../resources';
import { collision_groups } from '../../scenes/level-one/collision_groups';
import { LevelOne } from '../../scenes/level-one/level-one';
import { range } from '../../util';

abstract class Enemy extends Actor {
    private turns: number[][]
    private turnNum: number
    private positions: number[]
    private movingVel;
    private scale1: number;
    public distanceTraveled = 0;

    constructor(
        protected level: LevelOne,
        protected speed = 100,
        protected health = 3,
        protected horizontal: Animation,
        protected verticalAnimation: Animation,
    ) {
        super({
            x: 10, y: 510,
            width: 20, height: 10, color: Color.Red,
            collisionGroup: collision_groups.enemyGroup,
        });
        this.movingVel = vec(speed, -speed * 0.025)
        this.scale1 = 0.24
        this.turnNum = 0
        this.turns = [
            [0, 6, 8],
            [1, 5, 9],
            [2, 4],
            [7],
            [3]
        ]
        this.positions = [450, 160, 870, 705, 280, 970, 1600, 670, 1300, 280];
    }

    onInitialize() {
        this.horizontal.scale = vec(this.scale1, this.scale1);

        this.graphics.use(
            this.horizontal
        );

        this.verticalAnimation.scale = vec(this.scale1, this.scale1);
    }

    takeDamage(damage: number) {
        this.health -= damage
        if (this.health <= 0) {
            this.kill()
        }
    }
    
    rotate(turnNumber)
    {
        switch(turnNumber){
            case 0:
                if(this.pos.x > this.positions[0]){
                    this.goUp();
                    this.pos = vec(480, 470);
                    this.turnNum++;
                }
                break;
            case 1:
                if(this.pos.y < this.positions[1]){
                    this.goRight();
                    this.turnNum++;
                }
                break;
            case 2:
                if(this.pos.x > this.positions[2]){
                    this.goDown();
                    this.pos = vec(890, 160);
                    this.turnNum++;
                }
                break;
            case 3:
                if(this.pos.y > this.positions[3]){
                    this.goLeft1();
                    this.pos = vec(870,705);
                    this.turnNum++;
                }
                break;
            case 4:
                if(this.pos.x < this.positions[4]){
                    this.goDown();
                    this.turnNum++;
                }
                break;
            case 5:
                if(this.pos.y > this.positions[5]){
                    this.goRight();
                    this.turnNum++;
                }
                break;
            case 6:
                if(this.pos.x > this.positions[6]-40){
                    this.turnUp();
                }
                if(this.pos.x > this.positions[6]+10){
                    this.goUp();
                    this.pos = vec(1630,930);
                    this.turnNum++;
                }
                break;
            case 7:
                if(this.pos.y < this.positions[7]){
                    this.goLeft();
                    this.pos = vec(1600,620);
                    this.turnNum++;
                }
                break;
            case 8:
                if(this.pos.x < this.positions[8]){
                    this.goUp();
                    this.pos = vec(1300,600);
                    this.turnNum++;
                }
                break;
            case 9:
                if(this.pos.y < this.positions[9]){
                    this.goRight();
                    this.pos = vec(1300,260);
                    this.turnNum++;
                }
                break;
        }

        /*
        if(this.turns[0].includes(turnNumber)){
        this.goUp();
        }   
        if(this.turns[1].includes(turnNumber)){
        this.goRight();
        }   
        if(this.turns[2].includes(turnNumber)){
        this.goDown();
        }   
        if(this.turns[3].includes(turnNumber)){
        this.goLeft();
        }
        if(this.turns[4].includes(turnNumber)){
        this.goLeft1();
        }
            
        if(this.pos.x + this.width > 400)
        {
            this.goDown();
        }
        if(this.pos.y > 400)
        {
            this.goRight();
        }
        if(this.pos.x > 600)
        {
            this.goUp();
        }
        */
    }

    goDown()
    {
        this.movingVel = new Vector(0, this.speed);
        this.graphics.use(this.verticalAnimation);
        this.verticalAnimation.flipVertical = true;
    }

    goUp()
    {
        this.movingVel = new Vector(0, -this.speed)
        this.graphics.use(this.verticalAnimation);
        this.verticalAnimation.flipVertical = false;
    }

    goRight()
    {
        this.movingVel = new Vector(this.speed, 0)
        this.graphics.use(this.horizontal);
        this.horizontal.flipHorizontal = false;
    }
    
    goLeft()
    {
        this.movingVel = new Vector(-this.speed, 0)
        this.graphics.use(this.horizontal);
        this.horizontal.flipHorizontal = true;
    }
    goLeft1()
    {
        this.movingVel = new Vector(-this.speed, 18)
        this.graphics.use(this.horizontal);
        this.horizontal.flipHorizontal = true;
    }

    turnUp()
    {
        this.movingVel = new Vector(this.speed, -50)
        this.graphics.use(this.horizontal);
        this.horizontal.flipHorizontal = false;
    }

    onPostUpdate(engine: Engine, delta: number) {        
        this.rotate(this.turnNum);

        if (this.level.rolling) {
            this.vel = this.movingVel;
            this.distanceTraveled += this.vel.size * delta;
        } else {
            this.vel = new Vector(0, 0);
        }

        if (this.isOffScreen) {
            this.kill();
            this.level.damage();
        }
    }
}

export { Enemy }
